import script from "./BankDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BankDetails.vue?vue&type=script&setup=true&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=317382a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317382a4"]])

export default __exports__